class PaymentMethodsDrawer extends HTMLElement {
  constructor() {
    super();
    
    this.drawer = this;
    this.closeButton = this.querySelector('[data-drawer-close]');
    this.triggers = document.querySelectorAll('[data-payment-drawer-trigger]');
    
    // Determinar quais métodos de pagamento estão habilitados
    this.creditEnabled = this.querySelector('#payment-tab-credit') !== null;
    this.pixEnabled = this.querySelector('#payment-tab-pix') !== null;
    this.boletoEnabled = this.querySelector('#payment-tab-boleto') !== null;
    
    // Encontrar qual aba deve estar ativa inicialmente
    let activeTabName = 'credit';
    if (!this.creditEnabled) {
      if (this.pixEnabled) {
        activeTabName = 'pix';
      } else if (this.boletoEnabled) {
        activeTabName = 'boleto';
      }
    }
    
    this.activeTab = activeTabName;
    this.tabTriggers = this.querySelectorAll('[data-tab-trigger]');
    this.tabPanels = this.querySelectorAll('[data-tab-content]');
    
    this.isOpen = false;
    
    // Garantir que bodyScrollLock está disponível como objeto global
    if (typeof window.bodyScrollLock !== 'undefined') {
      this.bodyScrollLock = window.bodyScrollLock;
    }
    
    this.bindEvents();
    this.setupPriceUpdates();
    this.updateCurrentPrice(); // Ainda mantemos como fallback inicial
  }
  
  bindEvents() {
    // Open drawer triggers
    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.open(trigger);
      });
    });
    
    // Close drawer events
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.close());
    }
    
    // Close on click outside
    document.addEventListener('click', this.handleOutsideClick.bind(this));
    
    // Tab navigation
    this.tabTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        const tabName = trigger.dataset.tabTrigger;
        this.switchTab(tabName);
      });
    });
    
    // ESC key to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });
  }
  
  handleOutsideClick = (event) => {
    if (!this.isOpen) return;
    
    const drawerInner = this.querySelector(".payment-methods__inner");
    const triggerElement = event.target.closest('[data-payment-drawer-trigger]');
    
    if (drawerInner && !drawerInner.contains(event.target) && !triggerElement) {
      this.close();
    }
  };
  
  open(opener) {
    if (opener) this.setActiveElement(opener);
    
    this.isOpen = true;
    this.setAttribute('aria-hidden', 'false');
    this.classList.add("is-visible");
    document.documentElement.classList.add('overflow-hidden');
    
    if (this.bodyScrollLock) {
      this.bodyScrollLock.disableBodyScroll(this.querySelector('.payment-methods__inner'));
    }
    
    // Update trigger button state
    this.triggers.forEach(trigger => {
      trigger.setAttribute('aria-expanded', 'true');
    });
    
    // Usar setTimeout em vez de transitionend para garantir o foco
    setTimeout(() => {
      this.focusOnDrawer();
    }, 400);
    
    // Dispatch custom event
    this.dispatchEvent(new CustomEvent('payment-drawer:open'));
  }
  
  close() {
    this.isOpen = false;
    this.setAttribute('aria-hidden', 'true');
    this.classList.remove("is-visible");
    document.documentElement.classList.remove('overflow-hidden');
    
    if (this.bodyScrollLock) {
      this.bodyScrollLock.enableBodyScroll(this.querySelector('.payment-methods__inner'));
    }
    
    if (this.activeElement) {
      setTimeout(() => {
        this.activeElement.focus();
      }, 100);
    }
    
    // Update trigger button state
    this.triggers.forEach(trigger => {
      trigger.setAttribute('aria-expanded', 'false');
    });
    
    // Dispatch custom event
    this.dispatchEvent(new CustomEvent('payment-drawer:close'));
  }
  
  setActiveElement(element) {
    this.activeElement = element;
  }

  focusOnDrawer() {
    const focusElement = this.closeButton;
    if (focusElement) {
      focusElement.focus();
    }
  }
  
  switchTab(tabName) {
    // Update triggers
    this.tabTriggers.forEach(trigger => {
      const isActive = trigger.dataset.tabTrigger === tabName;
      trigger.classList.toggle('active', isActive);
      trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    
    // Update panels
    this.tabPanels.forEach(panel => {
      const isActive = panel.dataset.tabContent === tabName;
      panel.classList.toggle('active', isActive);
    });
    
    this.activeTab = tabName;
  }
  
  // MODIFICADO: Alterado para encontrar o preço com estratégia melhorada
  updateCurrentPrice() {
    // Primeiro tentamos encontrar o contêiner principal do produto
    const productContainer = document.querySelector(
      '.product__content, .product__info-wrapper, .product-form__container, form[data-product-form], [data-product-price-wrapper]'
    );
    
    let price = 0;
    let priceElement = null;
    
    if (productContainer) {
      console.log('Contêiner do produto encontrado:', productContainer);
      
      // Buscar apenas dentro do contêiner principal do produto
      const productPriceSelectors = [
        '.price__sale-price__value',
        '.price__regular-price',
        '.price .money',
        '.price__sale .money',
        '.price__current .money',
        '.product__price .money'
      ];
      
      for (const selector of productPriceSelectors) {
        const elements = productContainer.querySelectorAll(selector);
        if (elements.length) {
          priceElement = elements[0];
          price = this.extractPrice(priceElement.textContent);
          console.log(`Dentro do contêiner principal - ${selector} encontrou:`, priceElement, 'preço extraído:', price);
          if (price > 0) break;
        }
      }
    }
    
    // Se não encontrou no contêiner, tentar com seletores específicos para o produto principal
    if (price <= 0) {
      const specificProductSelectors = [
        '.product__price .price__sale-price__value',
        '.product__info-container .price .money', 
        '.product__price-container .price__regular-price',
        '.product-form__container .money',
        '[data-product-price-wrapper] .price__regular-price'
      ];
      
      for (const selector of specificProductSelectors) {
        const element = document.querySelector(selector);
        if (element) {
          priceElement = element;
          price = this.extractPrice(element.textContent);
          console.log(`Seletor específico de produto ${selector} encontrou:`, element, 'preço extraído:', price);
          if (price > 0) break;
        }
      }
    }
    
    // Verificar atributos de dados no formulário como último recurso
    if (price <= 0) {
      const productForm = document.querySelector('form[data-product-form]');
      if (productForm) {
        const dataPrice = productForm.getAttribute('data-price');
        if (dataPrice) {
          price = parseFloat(dataPrice) / 100; // Shopify armazena preços em centavos
          console.log('[DATA-PRICE] Obtido diretamente do formulário:', price);
        }
        
        // Tentar também via input da variante selecionada
        const variantInput = productForm.querySelector('input[name="id"]:checked, select[name="id"]');
        if (variantInput) {
          const variantId = variantInput.value;
          const variantElement = document.querySelector(`[data-product-variant-id="${variantId}"]`);
          if (variantElement && variantElement.getAttribute('data-price')) {
            price = parseFloat(variantElement.getAttribute('data-price')) / 100;
            console.log('[DATA-VARIANT] Obtido da variante selecionada:', price);
          }
        }
      }
    }
    
    if (price > 0) {
      console.log('Preço final encontrado:', price, 'do elemento:', priceElement);
      this.updatePrices(price);
    } else {
      console.log('Nenhum preço válido encontrado no DOM. Aguardando evento de atualização de variante.');
    }
  }

  extractPrice(priceString) {
    if (!priceString) return 0;
    
    console.log('Extraindo preço de:', priceString);
    
    // Remove "R$", espaços, e limpa a string
    let cleanPrice = priceString
      .replace(/R\$/gi, '')
      .replace(/\s+/g, '')
      .trim();
    
    // Para formato brasileiro: 1.234,56 -> 1234.56
    if (cleanPrice.includes(',')) {
      // Se tem vírgula, assume formato brasileiro
      cleanPrice = cleanPrice
        .replace(/\./g, '') // Remove pontos (separadores de milhar)
        .replace(',', '.'); // Converte vírgula para ponto decimal
    }
    
    // Extrai apenas números e ponto decimal
    const match = cleanPrice.match(/[\d.]+/);
    
    if (match && match[0]) {
      const price = parseFloat(match[0]);
      console.log('Preço extraído:', price);
      return isNaN(price) ? 0 : price;
    }
    
    return 0;
  }

  updatePrices(price) {
    console.log('Atualizando todos os preços para:', price);
    
    // Atualizar tabela de parcelamento
    if (this.creditEnabled) {
      this.updateInstallments(price);
    }
    
    // Atualizar preço PIX
    if (this.pixEnabled) {
      this.updatePixPrice(price);
    }
    
    // Atualizar preço Boleto
    if (this.boletoEnabled) {
      this.updateBoletoPrice(price);
    }
    
    // Dispatch evento para outras partes do sistema
    this.dispatchEvent(new CustomEvent('payment-methods:price-updated', {
      detail: { price: price }
    }));
  }

  // SUBSTITUÍDO: Nova implementação para usar sistema pub/sub
  setupPriceUpdates() {
    console.log('Configurando listeners de eventos para atualizações de preço...');
    
    // 1. Configurar listener para o evento principal de variante (PUB_SUB_EVENTS.variantChange)
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      console.log('Sistema pub/sub detectado, escutando PUB_SUB_EVENTS.variantChange');
      
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, (eventData) => {
        console.log('Evento variantChange recebido via pub/sub:', eventData);
        
        if (eventData?.data?.variant) {
          const variant = eventData.data.variant;
          const price = variant.price ? variant.price / 100 : 0;
          if (price > 0) {
            console.log('Atualizando preço via variantChange (pub/sub):', price);
            this.updatePrices(price);
          }
        }
      });
      
      // Também escutar evento de seleção de opção como fallback
      window.subscribe('optionValueSelectionChange', (eventData) => {
        console.log('optionValueSelectionChange detectado, verificando preço em 300ms');
        setTimeout(() => {
          // Este evento dispara antes que o preço seja atualizado, então adicionamos um delay
          this.updateCurrentPrice();
        }, 300);
      });
    } else {
      console.log('Sistema pub/sub não detectado, usando fallbacks de eventos DOM');
    }
    
    // 2. Configurar listeners para eventos de variante padrão
    const variantEvents = [
      'variant-change', 
      'variant:change', 
      'variant:changed', 
      'product:variant:change', 
      'product:variant-change'
    ];
    
    variantEvents.forEach(eventType => {
      document.addEventListener(eventType, (event) => {
        console.log(`Evento ${eventType} detectado:`, event);
        
        const variant = event.detail?.variant || event.detail || event.data?.variant;
        
        if (variant && variant.price) {
          const price = variant.price / 100;
          console.log(`Atualizando preço via ${eventType}:`, price);
          this.updatePrices(price);
        } else {
          // Se o evento não contém dados de preço, tentar ler do DOM
          setTimeout(() => this.updateCurrentPrice(), 200);
        }
      });
      
      console.log(`Listener configurado para evento: ${eventType}`);
    });
    
    // 3. Observer de fallback para mudanças nos elementos de preço 
    // (manter para compatibilidade, mas com prioridade menor)
    const priceContainers = document.querySelectorAll(
      '.product__price, .price__container, .price, [data-product-price-wrapper]'
    );
    
    if (priceContainers.length) {
      console.log('Configurando observers de fallback para containers de preço:', priceContainers.length);
      
      priceContainers.forEach(container => {
        const observer = new MutationObserver((mutations) => {
          console.log('Mudança detectada em container de preço:', mutations);
          setTimeout(() => this.updateCurrentPrice(), 150);
        });
        
        observer.observe(container, {
          childList: true,
          subtree: true,
          characterData: true
        });
      });
    }
  }
  
  updateInstallments(price) {
    const installmentRows = this.querySelectorAll('.payment-installments__row');
    if (!installmentRows.length) return;
    
    installmentRows.forEach((row, index) => {
      const installmentNumber = index + 1;
      const numberElement = row.querySelector('.payment-installments__number');
      const totalElement = row.querySelector('.payment-installments__total');
      
      if (!numberElement || !totalElement) return;
      
      // Get interest rate from data attributes
      const rateAttr = `data-installment_rate_${installmentNumber}`;
      let interestRate = 0;
      
      // Buscar a taxa no próprio elemento payment-methods-drawer
      if (this.hasAttribute(rateAttr)) {
        interestRate = parseFloat(this.getAttribute(rateAttr)) || 0;
      }
      
      // Calculate values
      let totalPrice = price;
      let installmentValue = price;
      
      if (interestRate > 0 && installmentNumber > 1) {
        totalPrice = price * (1 + interestRate / 100);
        installmentValue = totalPrice / installmentNumber;
      } else if (installmentNumber > 1) {
        installmentValue = price / installmentNumber;
      }
      
      // Update elements
      if (installmentNumber === 1) {
        numberElement.textContent = 'À vista';
      } else {
        numberElement.textContent = `${installmentNumber}x de R$ ${installmentValue.toFixed(2).replace('.', ',')}`;
      }
      
      totalElement.textContent = `R$ ${totalPrice.toFixed(2).replace('.', ',')}`;
    });
    
    console.log('Tabela de parcelamento atualizada para o preço:', price);
  }
  
  updatePixPrice(price) {
    // Verificar novamente se o tab existe e se há containers de preço
    if (!this.pixEnabled) return;
    
    const pixContainers = this.querySelectorAll('#payment-tab-pix .payment-method__price-value');
    if (!pixContainers.length) return;
    
    pixContainers.forEach(pixContainer => {
      const pixDiscountRate = parseFloat(this.getAttribute('data-pix-discount-rate')) || 0;
      const discountAmount = price * (pixDiscountRate / 100);
      const finalPrice = price - discountAmount;
      
      pixContainer.textContent = `R$ ${finalPrice.toFixed(2).replace('.', ',')}`;
    });
    
    // Atualizar badge de desconto se existir
    const pixDiscountBadge = this.querySelector('#payment-tab-pix .payment-method__discount-badge');
    if (pixDiscountBadge) {
      const pixDiscountRate = parseFloat(this.getAttribute('data-pix-discount-rate')) || 0;
      if (pixDiscountRate > 0) {
        pixDiscountBadge.textContent = `${pixDiscountRate}% OFF`;
      }
    }
  }
  
  updateBoletoPrice(price) {
    // Verificar novamente se o tab existe e se há containers de preço
    if (!this.boletoEnabled) return;
    
    const boletoContainers = this.querySelectorAll('#payment-tab-boleto .payment-method__price-value');
    if (!boletoContainers.length) return;
    
    boletoContainers.forEach(boletoContainer => {
      const boletoDiscountRate = parseFloat(this.getAttribute('data-boleto-discount-rate')) || 0;
      const discountAmount = price * (boletoDiscountRate / 100);
      const finalPrice = price - discountAmount;
      
      boletoContainer.textContent = `R$ ${finalPrice.toFixed(2).replace('.', ',')}`;
    });
    
    // Atualizar badge de desconto se existir
    const boletoDiscountBadge = this.querySelector('#payment-tab-boleto .payment-method__discount-badge');
    if (boletoDiscountBadge) {
      const boletoDiscountRate = parseFloat(this.getAttribute('data-boleto-discount-rate')) || 0;
      if (boletoDiscountRate > 0) {
        boletoDiscountBadge.textContent = `${boletoDiscountRate}% OFF`;
      }
    }
  }
}

// Register custom element
if (!customElements.get('payment-methods-drawer')) {
  customElements.define('payment-methods-drawer', PaymentMethodsDrawer);
}

// Inicialização explícita dos drawers
document.addEventListener('DOMContentLoaded', () => {
  const paymentDrawers = document.querySelectorAll('payment-methods-drawer');
  if (paymentDrawers.length > 0) {
    console.log('Inicializando payment-methods-drawer, quantidade:', paymentDrawers.length);
  }
});

// Carregar bodyScrollLock explicitamente se necessário
if (typeof window.bodyScrollLock === 'undefined' && typeof bodyScrollLock !== 'undefined') {
  window.bodyScrollLock = bodyScrollLock;
}